import { render, staticRenderFns } from "./CardMemberOld.vue?vue&type=template&id=f04e8020"
import script from "./CardMemberOld.vue?vue&type=script&lang=js"
export * from "./CardMemberOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports